import React, { forwardRef, useState } from 'react';
import type { TextInput, TextInputProps } from 'react-native';
import { TouchableOpacity } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import FormField from './FormField';
import { getPasswordAutofillProps } from 'src/presentation/helpers/passwordAutofill';
import Colors from 'src/core/utils/Colors';

interface PasswordFieldProps extends Pick<TextInputProps, 'returnKeyType' | 'onSubmitEditing' | 'blurOnSubmit'> {
	label: string;
	value: string;
	onChangeText: (text: string) => void;
	placeholder?: string;
	onBlur?: () => void;
	required?: boolean;
	error?: string;
}

const PasswordField = forwardRef<TextInput, PasswordFieldProps>(({ label, onBlur, required, error, ...props }, ref) => {
	const [visible, setVisible] = useState(false);

	return (
		<FormField
			error={error}
			label={label}
			ref={ref}
			required={required}
			rightElement={
				<TouchableOpacity style={{ position: 'absolute', right: 0, bottom: 16 }} onPress={() => setVisible((v) => !v)}>
					<Ionicons
						name={visible ? 'eye-off' : 'eye'}
						size={26}
						style={{ color: visible ? Colors.secondary : Colors.lightGrey }}
					/>
				</TouchableOpacity>
			}
			secureTextEntry={!visible}
			onBlur={onBlur}
			{...props}
			{...getPasswordAutofillProps()}
			autoCapitalize="none"
			autoCorrect={false}
		/>
	);
});

export default PasswordField;
